import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const Documentation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Documentation</h1>
            <p>
              Complete guide to get started with Optimus and make the most of
              our platform.
            </p>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="content-grid">
            <div className="content-card">
              <h3>🚀 Getting Started</h3>
              <p>
                Learn how to set up your account and get started with Optimus in
                minutes.
              </p>
              <Link to="/documentation" className="btn-outline">
                Read More
              </Link>
            </div>
            <div className="content-card">
              <h3>🔑 API Keys</h3>
              <p>
                Understand how to create and manage API keys for secure access
                to our services.
              </p>
              <Link to="/documentation/api-keys" className="btn-outline">
                View Guide
              </Link>
            </div>
            <div className="content-card">
              <h3>🤖 AI Training</h3>
              <p>
                Discover how to train your AI models and customize responses for
                your business.
              </p>
              <Link to="/documentation/ai-training" className="btn-outline">
                Learn More
              </Link>
            </div>
            <div className="content-card">
              <h3>💬 Chats</h3>
              <p>
                Monitor and analyze customer interactions with your AI-powered
                chat system.
              </p>
              <Link to="/documentation/chats" className="btn-outline">
                Explore
              </Link>
            </div>
            <div className="content-card">
              <h3>📊 Analytics</h3>
              <p>
                Get insights into your business performance with comprehensive
                analytics tools.
              </p>
              <Link to="/documentation/analytics" className="btn-outline">
                View Details
              </Link>
            </div>
            <div className="content-card">
              <h3>👤 Profile</h3>
              <p>
                Manage your account settings and business information
                effectively.
              </p>
              <Link to="/documentation/profile" className="btn-outline">
                Read Guide
              </Link>
            </div>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default Documentation;
